<template>
  <el-dialog title="铺货配置" :visible.sync="dialogVisible" width="90%">
    <div class="from-gyl-conf">
      <component :is="platform" :back="back" />
    </div>
    <!-- 铺货工具铺货配置 -->
    <template v-if="showDistribitionPage">
      <DistributionTool :platform="platform" pageType="DISTRIBUTION_SETTING" @destroyed="hideDistribitionPage"
        @redirect="hideDistribitionPage" />
    </template>
  </el-dialog>
</template>

<script>
import { PUHUO_INIT_PLATFORMS_MAP } from '@/dictionary/platforms';
import DistributionTool from '@/components/prod/center/components/WdInfoForm/index.vue';

export default {
  props: {
    activeName: {
      type: String,
      default: ''
    }
  },
  components: {
    ...PUHUO_INIT_PLATFORMS_MAP.reduce((compsMap, conf) => {
      compsMap[conf.path || conf.key] = conf.confComp
      return compsMap
    }, {}),
    DistributionTool
  },
  data() {
    return {
      dialogVisible: false,
      platforms: PUHUO_INIT_PLATFORMS_MAP,
      platform: 'ddian',
      showDistribitionPage: false,
    }
  },
  watch: {
    activeName(val) {
      this.getPlatformConf(val)
    }
  },
  methods: {
    method_open() {
      this.$fromGyl && this.getPlatformConf(this.activeName);
      this.dialogVisible = true;
    },
    getPlatformConf(val) {
      const item = this.platforms.find(item => item.key === val)
      this.platform = item?.path || item?.key
      if (this.platform === 'wd') {
        this.showDistribitionPage = true;
      }
    },
    back() {
      this.dialogVisible = false;
    },
    hideDistribitionPage() {
      this.showDistribitionPage = false;
    },
  }
}
</script>

<style lang="scss">
.from-gyl-conf {
  .ship-wrp {
    margin-left: 5px;
    display: flex;
    flex-wrap: wrap;
    .item {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 20px;

      &>div {
        margin-right: 16px;
      }

      .shopname {
        width: 150px;
        text-align: right;

        .shop-img {
          height: 26px;
          // border-radius: 50%;
          vertical-align: middle;
        }

        span {
          font-size: 12px;
          vertical-align: middle;
          display: inline-block;
          margin-left: 10px;
          color: #606266;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>